import { render, staticRenderFns } from "./StokProducts.vue?vue&type=template&id=3845c329&scoped=true&"
import script from "./StokProducts.vue?vue&type=script&lang=js&"
export * from "./StokProducts.vue?vue&type=script&lang=js&"
import style0 from "./StokProducts.vue?vue&type=style&index=0&id=3845c329&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3845c329",
  null
  
)

export default component.exports